module.exports = __webpack_public_path__ + "static/media/didou_show.e6ef955b.mp3";